import { HttpContextToken } from '@angular/common/http';

/** Marca llamadas públicas para que el interceptor no intente renovar un JWT. */
export const SKIP_AUTH_TOKEN_REFRESH = new HttpContextToken<boolean>(() => false);
